var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100vw"}},[_c('router-view',{staticStyle:{"padding":"20px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }